import { api } from './api';

export const fetchInvoicesItemReservations = (invoiceItemId, params, options) => {
  return api.get(`/invoice_item/${invoiceItemId}/sources/reservation`, params, options);
};

export const fetchInvoicesItemVehicles = (invoiceItemId, params, options) => {
  return api.get(`/invoice_item/${invoiceItemId}/sources/vehicle`, params, options);
};
